import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.hml-whatsappservice.consolare.com.br';

console.log('url', process.env.REACT_APP_API_URL)

// Criar instância única do axios
const api = axios.create({
  baseURL: API_URL,
  timeout: 120000, // 2 minutos (para geração de QR Code)
});

// Interceptor para adicionar token automaticamente
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    console.log('🔍 Debug - Interceptor de request:', {
      url: config.url,
      method: config.method,
      token: token ? 'Presente' : 'Ausente',
      headers: config.headers
    });

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para tratar respostas e erros
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expirado ou inválido
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
